import type { I18nFn } from 'i18n/types/I18nFn';

export enum RecencyPeriod {
  DEFAULT = '',
  PAST_24_HOURS = 'PAST_24_HOURS',
  PAST_WEEK = 'PAST_WEEK',
  PAST_MONTH = 'PAST_MONTH',
}

export function RECENCY_PERIODS(i18n: I18nFn) {
  return {
    '': i18n('Any time'),
    PAST_24_HOURS: i18n('Past 24 hours'),
    PAST_WEEK: i18n('Past week'),
    PAST_MONTH: i18n('Past month'),
  } satisfies Record<RecencyPeriod, string>;
}

export const RECENCY_PERIOD_RADIO_OR_SELECT_OPTIONS = (i18n: I18nFn) =>
  Object.entries(RECENCY_PERIODS(i18n)).map(([key, value]) => ({
    value: key,
    label: value,
  }));
